import type { CSSObject } from '@mui/material/styles';
import type { AnimationMixinProps } from 'layout/MainLayout/components/Sidebar/utils';

export const openedMixin = ({ theme }: AnimationMixinProps): CSSObject => ({
  transition: theme.transitions.create('all', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
});
